<template>
  <div
    v-cloak
    v-if="template && rules"
    class="item-common pt-10 pb-15 px-7 type-career"
  >
    <div class="header">
      <div class="d-flex">
        <h1 class="title">
          {{ $t(template.careerTitle) }}
          <span
            v-if="itemMaxLength && $i18n.locale == 'ko'"
            class="max-length-guide"
          >
            최대 {{ itemMaxLength }}개 입력 가능</span
          >
          <span
            v-if="itemMaxLength && $i18n.locale == 'en'"
            class="max-length-guide"
          >
            You can enter Max {{ itemMaxLength }}</span
          >
        </h1>
        <span class="ml-auto align-self-center">{{ totalmonth }}</span>
      </div>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideCareer"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <div class="mt-8" v-if="obj">
          <v-row>
            <v-col class="mt-n4" cols="3">
              <i-checkbox
                v-model="obj.isEmployed"
                true-value="Y"
                false-value="N"
                :label="`재직중`"
                hide-details="auto"
                @change="incareer(-1)"
                :readonly="isReadonly"
              ></i-checkbox>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col
              cols="12"
              :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
            >
              <v-row>
                <v-col cols="12" class="col-md-6" :class="colclass">
                  <i-text-field
                    v-model="obj.careerCompany"
                    v-maxlength="'career_company'"
                    :label="itemLabel('careerCompany')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('careerCompany', true),
                      rules.maxlength('careerCompany'),
                    ]"
                    :class="leftRoundedClass"
                  ></i-text-field>
                </v-col>
                <v-col cols="6" class="col-md-3" :class="colclass">
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('careerSdate')"
                    useMaxCurrentDate
                    :rules="[rules.required('careerSdate', true)]"
                    v-model="obj.startDate"
                    :type="careerSdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col cols="6" class="col-md-3" :class="colclass">
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('careerEdate')"
                    :min="obj.startDate"
                    useMaxCurrentDate
                    :disabled="obj.isEmployed == 'Y'"
                    :rules="[rules.required('careerEdate', true)]"
                    v-model="obj.endDate"
                    :type="careerEdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-none d-md-block pl-3 col-md-1">
              <i-btn elevation="0" color="primary" block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
          <template v-if="career !== 'A'">
            <v-row :class="rowclass">
              <v-col cols="12" class="col-md-4" :class="colclass">
                <i-select
                  :label="itemLabel('careerEmpType')"
                  :items="itemArray('careerEmpType')"
                  v-model="obj.careerEmpType"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required('careerEmpType', true)]"
                  :class="leftRoundedClass"
                ></i-select>
              </v-col>
              <v-col cols="6" class="col-md-4" :class="colclass">
                <i-text-field
                  :label="itemLabel('careerOrg')"
                  v-model="obj.careerOrg"
                  v-maxlength="'career_org'"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('careerOrg', true),
                    rules.maxlength('careerOrg'),
                  ]"
                  :class="lrzrclass"
                ></i-text-field>
              </v-col>
              <v-col cols="6" class="col-md-4" :class="colclass">
                <i-text-field
                  :label="itemLabel('careerPosition')"
                  v-model="obj.careerPosition"
                  v-maxlength="'career_position'"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('careerOrg', true),
                    rules.maxlength('careerOrg'),
                  ]"
                  class="rounded-r rounded-l-0"
                ></i-text-field>
              </v-col>
            </v-row>
            <template v-if="['E', 'F'].includes(career)">
              <v-row :class="rowclass">
                <v-col
                  v-for="type in career == 'F'
                    ? ['careerSalary', 'careerRevenue', 'careerNumEmps']
                    : ['careerSalary']"
                  cols="auto"
                  class="col-md-4"
                  :class="colclass"
                  :key="type"
                >
                  <i-text-field
                    :label="itemLabel(type)"
                    v-model="obj[type]"
                    v-maxlength="type"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[rules.required(type, true), rules.maxlength(type)]"
                    :class="lrzrclass"
                  ></i-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-if="['I'].includes(career)">
              <v-row :class="rowclass">
                <v-col
                  v-for="type in career == 'I'
                    ? [
                        'careerSalary',
                        'careerRevenue',
                        'careerNumEmps',
                        'careerGroup',
                        'careerTask',
                      ]
                    : ['careerSalary']"
                  cols="auto"
                  class="col-md-4"
                  :class="colclass"
                  :key="type"
                >
                  <i-text-field
                    :label="itemLabel(type)"
                    v-model="obj[type]"
                    v-maxlength="type"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[rules.required(type, true), rules.maxlength(type)]"
                    :class="lrzrclass"
                  ></i-text-field>
                </v-col>
              </v-row>
            </template>
          </template>

          <v-row :class="rowclass">
            <v-col cols="12" :class="colclass">
              <i-text-field
                :label="itemLabel('careerReason')"
                v-model="obj.careerReason"
                v-maxlength="'career_reason'"
                outlined
                dense
                hide-details="auto"
                :rules="[
                  rules.required('careerReason', true),
                  rules.maxlength('careerReason'),
                ]"
                :counter="itemLength('careerReason')"
              ></i-text-field>
            </v-col>
          </v-row>
          <v-row :class="rowclass">
            <v-col cols="12" :class="colclass">
              <i-textarea
                outlined
                :label="itemLabel('careerDesc')"
                v-model="obj.careerDesc"
                dense
                hide-details="auto"
                :rules="[
                  rules.required('careerDesc', true),
                  rules.maxlength('careerDesc'),
                ]"
                :disabled="itemLength('careerDesc') == 0"
                :readonly="isReadonly"
                :counter="itemLength('careerDesc')"
              ></i-textarea>
            </v-col>
          </v-row>
          <v-row v-if="fileUploadYn === 'Y'">
            <v-col cols="12" class="btn-post-wrap">
              <CVFileUpload
                ref="objFile"
                :label="itemLabel('careerFile')"
                :rules="[rules.required('careerFile', true)]"
                :bucketType="'temp'"
                :sectionKey="'career_temp'"
                :existingFileId="obj.careerFileId"
                :maxSize="itemLength('careerFile')"
                :isReadonly="isReadonly"
                @upload="uploadFile"
                @delete="deleteFile"
              ></CVFileUpload>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" class="d-md-none d-block">
              <i-btn elevation="0" color="normal" outlined block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm" :readonly="isReadonly">
        <template v-for="(item, i) in careers">
          <v-divider :key="'careerdiv' + i" v-if="i != 0"></v-divider>
          <div class="mt-8" v-if="item" :key="'career' + i">
            <v-row>
              <v-col class="mt-n4" cols="3">
                <i-checkbox
                  v-model="item.isEmployed"
                  true-value="Y"
                  false-value="N"
                  :label="`재직중`"
                  hide-details="auto"
                  @change="incareer(i)"
                  :readonly="isReadonly"
                ></i-checkbox>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col
                cols="12"
                :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
              >
                <v-row>
                  <v-col cols="12" class="col-md-6" :class="colclass">
                    <i-text-field
                      v-model="item.careerCompany"
                      v-maxlength="'career_company'"
                      :label="itemLabel('careerCompany')"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[
                        rules.required('careerCompany'),
                        rules.maxlength('careerCompany'),
                      ]"
                      @blur="save(i)"
                      :class="leftRoundedClass"
                    ></i-text-field>
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <CommonDatePicker
                      :readonly="isReadonly"
                      :label="itemLabel('careerSdate')"
                      useMaxCurrentDate
                      :rules="[rules.required('careerSdate')]"
                      v-model="item.startDate"
                      @change="save(i)"
                      :type="careerSdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                    />
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <CommonDatePicker
                      :readonly="isReadonly"
                      :label="itemLabel('careerEdate')"
                      :min="item.startDate"
                      :disabled="item.isEmployed == 'Y'"
                      :rules="[rules.required('careerEdate')]"
                      v-model="item.endDate"
                      @change="save(i)"
                      :type="careerEdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-none d-md-block pl-3 col-md-1" v-if="!isReadonly">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>

            <template v-if="career !== 'A'">
              <v-row :class="rowclass">
                <v-col cols="12" class="col-md-4" :class="colclass">
                  <i-select
                    :label="itemLabel('careerEmpType')"
                    :items="itemArray('careerEmpType')"
                    v-model="item.careerEmpType"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[rules.required('careerEmpType')]"
                    :class="leftRoundedClass"
                  ></i-select>
                </v-col>
                <v-col cols="6" class="col-md-4" :class="colclass">
                  <i-text-field
                    :label="itemLabel('careerOrg')"
                    v-model="item.careerOrg"
                    v-maxlength="'career_org'"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('careerOrg'),
                      rules.maxlength('careerOrg'),
                    ]"
                    :class="lrzrclass"
                  ></i-text-field>
                </v-col>
                <v-col cols="6" class="col-md-4" :class="colclass">
                  <i-text-field
                    :label="itemLabel('careerPosition')"
                    v-model="item.careerPosition"
                    v-maxlength="'career_position'"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('careerOrg'),
                      rules.maxlength('careerOrg'),
                    ]"
                    class="rounded-r rounded-l-0"
                  ></i-text-field>
                </v-col>
              </v-row>
              <template v-if="['E', 'F'].includes(career)">
                <v-row :class="rowclass">
                  <v-col
                    v-for="type in career == 'F'
                      ? ['careerSalary', 'careerRevenue', 'careerNumEmps']
                      : ['careerSalary']"
                    cols="auto"
                    class="col-md-4"
                    :class="colclass"
                    :key="type"
                  >
                    <i-text-field
                      :label="itemLabel(type)"
                      v-maxlength="type"
                      v-model="item[type]"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[rules.required(type), rules.maxlength(type)]"
                      :class="lrzrclass"
                    ></i-text-field>
                  </v-col>
                </v-row>
              </template>
              <template v-if="['I'].includes(career)">
                <v-row :class="rowclass">
                  <v-col
                    v-for="type in career == 'I'
                      ? [
                          'careerSalary',
                          'careerRevenue',
                          'careerNumEmps',
                          'careerGroup',
                          'careerTask',
                        ]
                      : ['careerSalary']"
                    cols="auto"
                    class="col-md-4"
                    :class="colclass"
                    :key="type"
                  >
                    <i-text-field
                      v-maxlength="type"
                      :label="itemLabel(type)"
                      v-model="item[type]"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[rules.required(type), rules.maxlength(type)]"
                      :class="lrzrclass"
                    ></i-text-field>
                  </v-col>
                </v-row>
              </template>
            </template>

            <v-row :class="rowclass">
              <v-col cols="12" :class="colclass">
                <i-text-field
                  :label="itemLabel('careerReason')"
                  v-model="item.careerReason"
                  v-maxlength="'career_reason'"
                  outlined
                  dense
                  hide-details="auto"
                  @blur="save(i)"
                  :rules="[
                    rules.required('careerReason'),
                    rules.maxlength('careerReason'),
                  ]"
                  :counter="itemLength('careerReason')"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
            </v-row>
            <v-row :class="rowclass">
              <v-col cols="12" :class="colclass">
                <i-textarea
                  outlined
                  :label="itemLabel('careerDesc')"
                  v-model="item.careerDesc"
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('careerDesc'),
                    rules.maxlength('careerDesc'),
                  ]"
                  :counter="itemLength('careerDesc')"
                  @blur="save(i)"
                  :disabled="itemLength('careerDesc') == 0"
                  :readonly="isReadonly"
                ></i-textarea>
              </v-col>
            </v-row>
            <v-row v-if="fileUploadYn === 'Y'">
              <v-col cols="12" class="btn-post-wrap">
                <CVFileUpload
                  :label="itemLabel('careerFile')"
                  :sectionKey="'career' + item.seq"
                  :rules="[rules.required('careerFile')]"
                  :existingFileId="item.careerFileId"
                  :maxSize="itemLength('careerFile')"
                  :isReadonly="isReadonly"
                  @upload="uploadFile"
                  @delete="deleteFile"
                ></CVFileUpload>
              </v-col>
            </v-row>
            <v-row class="mt-2" v-if="!isReadonly">
              <v-col cols="12" class="d-md-none d-block">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>
          </div>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import { LoadingMixin } from '@/mixin/loading.js';
import { mdiCalendarBlank } from '@mdi/js';
import CVFileUpload from './CVFileUpload.vue';
import { resumeType } from '@/const/resumeType';
import { equals } from '@/utils/util';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import { snack } from '@/plugins/dialog/api';

export default {
  mixins: [LoadingMixin],
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  components: {
    CVFileUpload,
    CommonDatePicker,
  },
  mounted() {
    this.setting();
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.career?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.career?.oMaxLength ||
        this.opts.career?.oMaxLength > this.careers.length
      );
    },
    rowclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    lrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-l':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-r-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    rrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-r':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-l-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    totalmonth: function() {
      var month = 0;

      if (this.careers && this.careers.length > 0) {
        var $this = this;
        this.careers.forEach(function(v) {
          if (
            (v.startDate && v.endDate) ||
            (v.startDate && !v.endDate && v.isEmployed === 'Y')
          ) {
            const [syear, smonth] = v.startDate.split('-');

            var s = new Date(syear, smonth - 1);
            var e = new Date();

            if (v.endDate) {
              const [eyear, emonth] = v.endDate.split('-');
              e = new Date(eyear, emonth - 1);
            }

            month += $this.monthdiff(s, e);
          }
        });
      }

      if (month / 12 >= 1) {
        return (
          `${(month / 12) | 0}` +
          this.$t('년') +
          `${month % 12}` +
          this.$t('개월')
        );
      }
      return `${month}` + this.$t('개월');
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
  },
  data: () => ({
    mdiCalendarBlank,
    itemDelimeter: '#',
    itemSeq: 1,
    obj: null,
    career: '',
    careers: [],
    fileUploadYn: '',
    careerSdateFormat: '',
    careerEdateFormat: '',
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
    careerGroup: '',
    careerTask: '',
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }

      if (key === 'careerFile')
        label += this.$t(' [최대크기 : ') + this.itemLength(key) + 'MB]';

      return label;
    },
    itemLength: function(key) {
      var length = 0;
      if (this.opts && this.opts.hasOwnProperty(key)) {
        var defaultLength =
          key.indexOf('file') >= 0 || key.indexOf('File') >= 0 ? 2 : 0;
        length = this.opts[key].oLength
          ? this.opts[key].oLength
          : defaultLength;
      }
      return length;
    },
    itemArray: function(key) {
      var array = [];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        array = this.opts[key].oItems
          ? this.opts[key].oItems.split(this.itemDelimeter)
          : [];
      }
      return array;
    },
    setting() {
      //DATE VALIDATE RULE SET

      const type = resumeType.typeCareer[this.template.typeCareer];

      if (type) {
        const items = type.filter(v => v != 'careerFile');
        this.fileUploadYn = type.includes('careerFile') ? 'Y' : 'N';
        this.career = Object.keys(resumeType.typeCareer).find(key =>
          equals(items, resumeType.typeCareer[key]),
        );
      }

      if (this.opts) {
        let $this = this;
        for (let key in this.opts) {
          let prop = this.opts[key];
          if (prop.id.cvColumn === 'careerSdate') {
            $this.careerSdateFormat = prop.oFormat;
          } else if (prop.id.cvColumn === 'careerEdate') {
            $this.careerEdateFormat = prop.oFormat;
          }
        }
      }
      this.dataSetting();
      this.obj = this.defaultObj();
    },
    dataSetting: function() {
      if (this.info && this.info.careers && this.info.careers.length > 0) {
        this.itemSeq = this.info.careers[0].id.seq;
        this.careers = [];

        let $this = this;
        this.info.careers.forEach(function(v) {
          var startDate = '';
          var endDate = '';

          if (v.careerSdate) {
            const date = [
              v.careerSdate.substring(0, 4),
              v.careerSdate.substring(4, 6),
              v.careerSdate.substring(6, 8),
            ];
            $this.careerSdateFormat === 'YYYY.MM' && date.pop();
            startDate = date.filter(v => v).join('-');
          }

          if (v.careerEdate) {
            const date = [
              v.careerEdate.substring(0, 4),
              v.careerEdate.substring(4, 6),
              v.careerEdate.substring(6, 8),
            ];
            $this.careerEdateFormat === 'YYYY.MM' && date.pop();
            endDate = date.filter(v => v).join('-');
          }
          let obj = {
            ...v,
            seq: v.id.seq,
            isEmployed: v.careerInYn ? v.careerInYn : 'N',
            careerFileId: v.careerFileId ? v.careerFileId : null,
            startDate,
            endDate,
          };

          $this.careers.push(obj);
          $this.itemSeq =
            $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
        });
      }
    },
    defaultObj: function() {
      let obj = {
        seq: this.itemSeq++,
        isEmployed: 'N',
        careerCompany: '',
        careerSdate: '',
        careerEdate: '',
        careerEmpType: '',
        careerOrg: '',
        careerPosition: '',
        careerSalary: '',
        careerRevenue: '',
        careerNumEmps: '',
        careerReason: '',
        careerDesc: '',
        careerFileId: null,
        startDate: '',
        endDate: '',
        careerGroup: '',
        careerTask: '',
      };
      return obj;
    },
    add: function() {
      if (!this.canAdd && this.$i18n.locale == 'ko')
        return this.$showAlert(
          `${this.template.careerTitle} 은(는) 최대 ${this.opts.career.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      else if (!this.canAdd && this.$i18n.locale == 'en')
        return this.$showAlert(
          `MaxSize of ${this.template.careerTitle} is ${this.opts.career.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },
    incareer: function(i) {
      var item = i === -1 ? this.obj : this.careers[i];

      if (item.isEmployed === 'Y') {
        item.endDate = '';
      }

      if (i !== -1) this.save(i);
    },

    monthdiff: function(d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
    valid: function() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.career &&
        this.opts.career.oRequireYn &&
        this.opts.career.oRequireYn == 'Y' &&
        this.careers.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      return this.$refs.updateForm.validate();
    },
    async save(i) {
      await this.$nextTick();
      var item = i === -1 ? this.obj : this.careers[i];
      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;
      const id = {
        annoId: this.$route.params.annoId,
        seq: item.seq,
      };

      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거

      const p = {
        id,
        ...Object.keys(item).reduce((a, key) => {
          /** @type {string} */
          if (key.startsWith('career')) a[key] = item[key];
          return a;
        }, {}),
        careerInYn: item.isEmployed,
        careerSdate: item.startDate?.replace(pattern, '') || '',
        careerEdate: item.endDate?.replace(pattern, '') || '',
      };

      this.$emit('save', p, 'career', i);
    },
    savecallback: function(res, i) {
      var item = i === -1 ? this.obj : this.careers[i];

      if (res.status !== 200) {
        console.log('CAREER SAVE FAIL');
      } else snack.info(`저장되었습니다.`);
      //SAVE FORM
      if (i === -1) {
        this.careers.push(this.obj);
        this.obj = this.defaultObj();
        this.$refs.saveForm.resetValidation();

        if (item.careerFileId) {
          this.applyFile(item.careerFileId);
        }
      }
    },
    delete: function(i) {
      this.showLoading();
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.careers[i].seq,
      };

      this.$emit('delete', p, 'career', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('CAREER DELETE FAIL');
      } else {
        snack.danger(`삭제되었습니다.`);
        this.careers.splice(i, 1);
      }
      this.hideLoading();
    },
    uploadFile(sectionKey, fileId) {
      if (sectionKey.indexOf('temp') > -1) {
        this.obj.careerFileId = String(fileId);
      } else {
        var seq = sectionKey.substring('career'.length, sectionKey.length);
        var idx = -1;
        this.careers.forEach(function(v, i) {
          if (String(v.seq) === seq) {
            v.careerFileId = fileId;
            idx = i;
          }
        });
        if (idx !== -1) this.save(idx);
      }
    },
    deleteFile(sectionKey) {
      var seq = sectionKey.substring('career'.length, sectionKey.length);
      var idx = -1;
      this.careers.forEach(function(v, i) {
        if (String(v.seq) === seq) {
          v.careerFileId = '';
          idx = i;
        }
      });
      if (idx !== -1) this.save(idx);
    },
    applyFile(fileId) {
      this.$emit('applyFile', 'career', fileId);
    },
    applyFilecallback: function(res) {
      if (res.status !== 200) {
        console.log('CAREER FILE APPLY FAIL');
      } else {
        this.$refs.objFile.initFiles();
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.type-career .sub-title-standard {
  position: relative;
}
.type-career .sub-title-standard .v-input__slot {
  padding-left: 100px !important;
}
.type-career .sub-title-standard .sub-title {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #363c43;
}
</style>
